import React from 'react'

import katsuhisa__ from '../../images/team/katsuhisa__.jpg'
import ktykogm from '../../images/team/ktykogm.jpg'
import okash1n from '../../images/team/okash1n.jpg'
import muziyoshiz from '../../images/team/muziyoshiz.png'
import maaaato from '../../images/team/maaaato.jpg'
import pataiji from '../../images/team/pataiji.jpg'
import m4buya from '../../images/team/m4buya.png'
import chaspy_ from '../../images/team/chaspy_.jpg'
import fukubaka0825 from '../../images/team/fukubaka0825.jpg'
import _48hikaru214 from '../../images/team/_48hikaru214.jpg'
import mtsuka from '../../images/team/mtsuka.jpg'
import bayashi_ok from '../../images/team/bayashi_ok.jpg'
import ykawamot from '../../images/team/ykawamot.jpg'
import inductor from '../../images/team/inductor.jpg'
import ogady from '../../images/team/ogady.jpg'
import saitotaq from '../../images/team/saitotaq.jpg'
import sogaoh from '../../images/team/sogaoh.jpg'
import move_fastest from '../../images/team/move_fastest.jpg'
import YamadaNoel from '../../images/team/YamadaNoel.jpg'
import rabbyrinth_kae2 from '../../images/team/rabbyrinth_kae2.jpg'

import komacchi_u from '../../images/team/1day/komacchi_u.jpg'
import eramuk from '../../images/team/1day/eramuk.jpg'
import CyberMergina from '../../images/team/1day/CyberMergina.jpg'
import iganari_ from '../../images/team/1day/iganari_.jpg'
import takashabe from '../../images/team/1day/takashabe.jpg'
import varu_3 from '../../images/team/1day/varu_3.jpg'
import saku_238 from '../../images/team/1day/saku_238.jpg'
import kuromitsu_ka from '../../images/team/1day/kuromitsu_ka.jpg'
import domb_ri from '../../images/team/1day/domb_ri.jpg'
import antiberial from '../../images/team/1day/antiberial.jpg'
import ka_zu53 from '../../images/team/1day/ka_zu53.jpg'
import majimasashi from '../../images/team/1day/majimasashi.jpg'
import _mttrs from '../../images/team/1day/_mttrs.jpg'
import ngoto95660708 from '../../images/team/1day/ngoto95660708.jpg'
import t_kuboi from '../../images/team/1day/t_kuboi.png'
import funamoto_takuto from '../../images/team/1day/funamoto_takuto.jpg'
import flightonary from '../../images/team/1day/flightonary.jpg'
import ozaken_AI from '../../images/team/1day/ozaken_AI.jpg'
import weekendcycler from '../../images/team/1day/weekendcycler.jpg'

const Team = () => (
  <section className="ts-blog section-bg">
    <a id="team" className="anchor" />
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <h2 className="section-title">
            <span>Team</span>
            運営スタッフ
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <div className="single-intro-text mb-30">
            <div>
              <h3 className="section-subtitle">コアスタッフ</h3>
              <div className="team-img">
                <a href="https://twitter.com/katsuhisa__">
                  <img src={katsuhisa__} alt="katsuhisa__" />
                </a>
                <a href="https://twitter.com/ktykogm">
                  <img src={ktykogm} alt="ktykogm" />
                </a>
                <a href="https://twitter.com/okash1n">
                  <img src={okash1n} alt="okash1n" />
                </a>
                <a href="https://twitter.com/muziyoshiz">
                  <img src={muziyoshiz} alt="muziyoshiz" />
                </a>
                <a href="https://twitter.com/maaaato">
                  <img src={maaaato} alt="maaaato" />
                </a>
                <a href="https://twitter.com/pataiji">
                  <img src={pataiji} alt="pataiji" />
                </a>
                <a href="https://twitter.com/m4buya">
                  <img src={m4buya} alt="m4buya" />
                </a>
                <a href="https://twitter.com/chaspy_">
                  <img src={chaspy_} alt="chaspy_" />
                </a>
                <a href="https://twitter.com/fukubaka0825">
                  <img src={fukubaka0825} alt="fukubaka0825" />
                </a>
                <a href="https://twitter.com/48hikaru214">
                  <img src={_48hikaru214} alt="48hikaru214" />
                </a>
                <a href="https://twitter.com/mtsuka">
                  <img src={mtsuka} alt="mtsuka" />
                </a>
                <a href="https://twitter.com/bayashi_ok">
                  <img src={bayashi_ok} alt="bayashi_ok" />
                </a>
                <a href="https://twitter.com/ykawamot">
                  <img src={ykawamot} alt="ykawamot" />
                </a>
                <a href="https://twitter.com/_inductor_">
                  <img src={inductor} alt="inductor" />
                </a>
                <a href="https://twitter.com/_ogady_">
                  <img src={ogady} alt="ogady" />
                </a>
                <a href="https://twitter.com/saitotaq">
                  <img src={saitotaq} alt="saitotaq" />
                </a>
                <a href="https://twitter.com/sogaoh">
                  <img src={sogaoh} alt="sogaoh" />
                </a>
                <a href="https://twitter.com/move_fastest">
                  <img src={move_fastest} alt="move_fastest" />
                </a>
                <a href="https://twitter.com/YamadaNoel">
                  <img src={YamadaNoel} alt="YamadaNoel" />
                </a>
                <a href="https://twitter.com/rabbyrinth_kae2">
                  <img src={rabbyrinth_kae2} alt="rabbyrinth_kae2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a id="staff" className="anchor" />
    <div className="container">
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <div className="single-intro-text mb-30">
            <div>
              <h3 className="section-subtitle">当日スタッフ</h3>
              <div className="team-img">
                <a href="https://twitter.com/komacchi_u">
                  <img src={komacchi_u} alt="komacchi_u" />
                </a>
                <a href="https://twitter.com/eramuk">
                  <img src={eramuk} alt="eramuk" />
                </a>
                <a href="https://twitter.com/CyberMergina">
                  <img src={CyberMergina} alt="CyberMergina" />
                </a>
                <a href="https://twitter.com/iganari_">
                  <img src={iganari_} alt="iganari_" />
                </a>
                <a href="https://twitter.com/takashabe">
                  <img src={takashabe} alt="takashabe" />
                </a>
                <a href="https://twitter.com/varu_3">
                  <img src={varu_3} alt="varu_3" />
                </a>
                <a href="https://twitter.com/saku_238">
                  <img src={saku_238} alt="saku_238" />
                </a>
                <a href="https://twitter.com/kuromitsu_ka">
                  <img src={kuromitsu_ka} alt="kuromitsu_ka" />
                </a>
                <a href="https://twitter.com/domb_ri">
                  <img src={domb_ri} alt="domb_ri" />
                </a>
                <a href="https://twitter.com/antiberial">
                  <img src={antiberial} alt="antiberial" />
                </a>
                <a href="https://twitter.com/ka_zu53">
                  <img src={ka_zu53} alt="ka_zu53" />
                </a>
                <a href="https://twitter.com/masashi_ue">
                  <img src={majimasashi} alt="majimasashi" />
                </a>
                <a href="https://twitter.com/_mttrs">
                  <img src={_mttrs} alt="_mttrs" />
                </a>
                <a href="https://twitter.com/ngoto95660708">
                  <img src={ngoto95660708} alt="ngoto95660708" />
                </a>
                <a href="https://twitter.com/t_kuboi">
                  <img src={t_kuboi} alt="t_kuboi" />
                </a>
                <a href="https://twitter.com/funamoto_takuto">
                  <img src={funamoto_takuto} alt="funamoto_takuto" />
                </a>
                <a href="https://twitter.com/flightonary">
                  <img src={flightonary} alt="flightonary" />
                </a>
                <a href="https://twitter.com/ozaken_AI">
                  <img src={ozaken_AI} alt="ozaken_AI" />
                </a>
                <a href="https://twitter.com/weekendcycler">
                  <img src={weekendcycler} alt="weekendcycler" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Team
